import { getActionTypeFromInstance, StateToken, type ActionType } from '@ngxs/store'
import * as FlatModels from '@medsurf/flat-models';

export interface ActionMetadata {
  ctor: unknown;
  actions: string[];
  stateTokens: StateToken<FlatModels.EntityStatesModels.EntityStateModel<FlatModels.Base | FlatModels.UserEntityModels.User>>[];
  types: FlatModels.EntityControlModels.HistorySnapshotItemModifierType[];
}

export const actionsToHandle: Record<string, ActionMetadata> = {}

export function Undoable(action: ActionType,
                         stateToken: StateToken<FlatModels.EntityStatesModels.EntityStateModel<FlatModels.Base | FlatModels.UserEntityModels.User>>,
                         type: FlatModels.EntityControlModels.HistorySnapshotItemModifierType) {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    const actionType = getActionTypeFromInstance(action)
    if (actionType) {
      const ctorName = target.constructor.name
      actionsToHandle[ctorName] = {
        ctor: target.constructor,
        actions: actionsToHandle[ctorName] ? [...actionsToHandle[ctorName].actions, actionType] : [actionType],
        stateTokens: actionsToHandle[ctorName] ? [...actionsToHandle[ctorName].stateTokens, stateToken] : [stateToken],
        types: actionsToHandle[ctorName] ? [...actionsToHandle[ctorName].types, type] : [type],
      }
    }
  }
}